export default __webpack_public_path__ + "static/media/error500.dd3c7644.svg";